export const MAX_SOURCE_IMAGE_PIXELS = 40_000_000;
export const MAX_UPLOAD_SOURCE_BYTES = 10 * 1024 * 1024;
const MAX_PREVIEW_EDGE = 960;

export async function createUploadPreview(file, options = {}) {
  if (!file || file.size > MAX_UPLOAD_SOURCE_BYTES) {
    throw new Error("FILE_TOO_LARGE");
  }
  const decode = options.decode || globalThis.createImageBitmap;
  if (typeof decode !== "function") throw new Error("IMAGE_DECODER_UNAVAILABLE");

  let bitmap;
  try {
    bitmap = await decode(file, { imageOrientation: "from-image" });
  } catch {
    throw new Error("IMAGE_DECODE_FAILED");
  }

  try {
    const sourceWidth = Number(bitmap.width);
    const sourceHeight = Number(bitmap.height);
    if (!sourceWidth || !sourceHeight || sourceWidth * sourceHeight > MAX_SOURCE_IMAGE_PIXELS) {
      throw new Error("IMAGE_DIMENSIONS_TOO_LARGE");
    }

    const ratio = Math.min(1, MAX_PREVIEW_EDGE / Math.max(sourceWidth, sourceHeight));
    const width = Math.max(1, Math.round(sourceWidth * ratio));
    const height = Math.max(1, Math.round(sourceHeight * ratio));
    const canvas = (options.createCanvas || createCanvas)(width, height);
    const context = canvas.getContext("2d", { alpha: false });
    if (!context) throw new Error("IMAGE_CANVAS_UNAVAILABLE");
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, width, height);
    context.drawImage(bitmap, 0, 0, width, height);
    const blob = await encodeJpeg(canvas);
    if (!blob || blob.type !== "image/jpeg" || !blob.size) throw new Error("IMAGE_ENCODE_FAILED");
    return { blob, width, height, sourceWidth, sourceHeight };
  } finally {
    bitmap.close?.();
  }
}

function createCanvas(width, height) {
  if (typeof globalThis.OffscreenCanvas === "function") return new OffscreenCanvas(width, height);
  if (typeof document === "undefined") throw new Error("IMAGE_CANVAS_UNAVAILABLE");
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  return canvas;
}

function encodeJpeg(canvas) {
  if (typeof canvas.convertToBlob === "function") {
    return canvas.convertToBlob({ type: "image/jpeg", quality: 0.86 });
  }
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("IMAGE_ENCODE_FAILED")), "image/jpeg", 0.86);
  });
}
